import { Box, Grid, Paper, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import VivaWalletStatus from '../../../components/paymethod/VivaWalletStatus';

import VivaISVSelect from '../../../components/paymethod/VivaISVSelect';
import useCompanyId from '../../../hooks/useCompanyId';
import { useIntegrationsList } from '../../../stores/FetcherStores/integrationFetcher';
import VivaSupport from './VivaSupport';

interface VivaIntegrationProps {
  integrationId: string;
}

const VivaIntegration: FC<VivaIntegrationProps> = ({ integrationId }) => {
  const { t } = useTranslation();
  const companyId = useCompanyId();
  const { data: integrations } = useIntegrationsList(companyId);

  const vivaIntegration = integrations?.find(
    (integration) => integration.type === 'VIVA' && integration.id === integrationId,
  );

  if (!vivaIntegration) {
    return (
      <Paper sx={{ padding: 2 }}>
        <Typography variant="h2" gutterBottom>
          {t('integration.notFound')}
        </Typography>
      </Paper>
    );
  }
  return (
    <Box>
      <Typography variant="h2" gutterBottom>
        Viva Wallet
      </Typography>
      <Grid item xs={12}>
        <VivaWalletStatus integrationId={integrationId} />
      </Grid>
      <Grid item xs={12} mb={2}>
        <VivaISVSelect integrationId={integrationId} />
      </Grid>
      <VivaSupport />
    </Box>
  );
};

export default VivaIntegration;
